import { localeKey } from "@constants/locale-key";
import PopularProduct from "@containers/PopularProduct";
import { TPopularProduct } from "@containers/PopularProduct/type";
import { canonicalLink } from "@helpers/url";
import Footer from "@layouts/Footer";
import Header from "@layouts/Main/lib/Header";
import { TProductIconData } from "@layouts/Main/lib/Header/lib/MenuProduct/type";
import { getPopularProduct } from "@libraries/api/popular-product/popular-product.repos";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { NextPage, NextPageContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

export interface IPropsRekomendasiProduk {
  dataPopularProducts: TPopularProduct[];
  dataNavbar: TProductIconData[];
}

const PageProdukRekomendasi: NextPage<IPropsRekomendasiProduk> = ({
  dataPopularProducts,
  dataNavbar,
}) => {
  return (
    <>
      <Header
        setExpand={function (): void {
          throw new Error("Function not implemented.");
        }}
        withoutNavigation
      />
      <PopularProduct dataPopularProducts={dataPopularProducts} />
      <Footer bgColor="white" dataNavbar={dataNavbar} />
    </>
  );
};

export async function getServerSideProps(context: NextPageContext) {
  const lang = `${context.locale}`;
  const limit = 30;

  context.res?.setHeader(
    "Cache-Control",
    "public, max-age=7884000, immutable"
  );

  const { data: dataProductMenu } = await getProductMenu({ level: 0 }, lang);
  const { data: dataPopularProducts } = await getPopularProduct(limit, lang);

  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? "id", localeKey)),
      title: "Produk Rekomendasi",
      description: "Produk dengan Penawaran Terbaik. Semua produk dan layanan yang paling populer",
      baseUrl: `//${context?.req?.headers.host}`,
      canonical: canonicalLink("/produk-rekomendasi", context.locale),
      imageUrl: "",
      dataNavbar: dataProductMenu,
      dataPopularProducts,
    },
  };
}

export default PageProdukRekomendasi;
